import { Component, OnInit } from '@angular/core';
import { Data2Service } from '../../common/data2.service';
import { BankHistoryOperations } from '../bank.model';

@Component({
	selector: 'app-bank-history-operations',
	templateUrl: './bank-history-operations.component.html',
	styleUrls: ['./bank-history-operations.component.css'],
})
export class BankHistoryOperationsComponent implements OnInit {
	data: BankHistoryOperations[];
	tableRows: { id: string; name: string }[] = [
		{
			id: 'date',
			name: 'Data operacji',
		},
		{
			id: 'name',
			name: 'Nazwa operacji',
		},
		{
			id: 'userName',
			name: 'Kto?',
		},
	];

	constructor(private readonly api: Data2Service) {}

	ngOnInit(): void {
		this.api.get('/bankHistoryOperations/', (result, error) => {
			this.data = result.data;
		});
	}
}
